import React, { Component } from "react";
import "../../assets/web/assets/mobirise-icons2/mobirise2.css";
import "../../assets/web/assets/mobirise-icons/mobirise-icons.css";
import "../../assets/tether/tether.min.css";
import "../../assets/material-design/css/material-icons.min.css";
import "../../assets/bootstrap/css/bootstrap.min.css";
import "../../assets/bootstrap/css/bootstrap-grid.min.css";
import "../../assets/bootstrap/css/bootstrap-reboot.min.css";
import "../../assets/dropdown/css/style.css";
import "../../assets/socicon/css/styles.css";
import "../../assets/theme/css/style.css";
import "../../assets/mobirise/css/mbr-additional.css";
import Header from "./navigation/Header";
import Footer from "./navigation/Footer";
import BusinessTransactionsTableComponent from "./BusinessTransactionsTableComponent";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { Modal, Button, Input, Switch } from "antd";
import { GetBusinessProfile } from "../../store/actions/profileActions";
import Loading from "../widgets/Loading";

const { TextArea } = Input;

class BusinessTransactionsPage extends Component {
  state = {
    fixclaimid: "",
    fixclaimreason: "",
    fixclaimmodal: false,
    fixclaimurgent: false,
  };

  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  componentDidMount() {
    document.title = "Loading...";
  }

  handleOk = () => {
    // this.props.addFixClaim({
    //   reason: this.state.fixclaimreason,
    //   businessId: this.props.profile.profile.id,
    //   transaction: this.state.fixclaimid,
    //   urgent: this.state.fixclaimurgent,
    // });
    this.setState({
      fixclaimmodal: false,
    });
  };

  handleFixForClaim = (id) => {
    this.setState({
      fixclaimid: id,
      fixclaimmodal: true,
    });
  };

  handleCancel = () => {
    this.setState({
      fixclaimmodal: false,
      fixclaimid: "",
    });
  };

  componentDidUpdate(prev, curr) {
    if (this.props.profile === null) {
      if (
        prev.firebase.profile.isLoaded === false &&
        this.props.firebase.profile.isLoaded === true
      ) {
        this.props.getBusiness();
      }
    }
  }

  render() {
    if (this.props.auth.uid && !this.props.auth.isAnonymous) {
      if (this.props.profile.profile !== null) {
        return (
          <div>
            <Header />
            <section className="info3 cid-ssS2vMoFjP" id="info3-1e">
              <div
                className="mbr-overlay"
                style={{ opacity: " 0.6", backgroundColor: "rgb(0, 0, 0)" }}
              />
              <div className="container">
                <div className="row justify-content-center">
                  <div className="card col-12 col-lg-9 col-md-8">
                    <div className="card-wrapper">
                      <div className="card-box align-center">
                        <h4 className="card-title mbr-fonts-style align-center mb-4 display-5">
                          <strong>Current Balance</strong>
                        </h4>
                        <p className="mbr-text mbr-fonts-style mb-4 display-1">
                          {this.props.profile.profile &&
                            this.numberWithCommas(
                              this.props.profile.profile.balance.toFixed(2)
                            )}{" "}
                          ETB
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    className="col-12 col-md-4 col-lg-3"
                    style={{ verticalAlign: "middle" }}
                  >
                    <a
                      className="btn btn-success display-4"
                      href="/business_deposit"
                      target="_blank"
                    >
                      <span className="material material-add mbr-iconfont mbr-iconfont-btn"></span>
                      DEPOSIT
                    </a>
                    {/* <Button
                    style={{ height: "auto" }}
                    type="primary"
                    onClick={() => {
                      window.location = "/business_deposit";
                    }}
                  >
                    <div>
                      <PlusOutlined
                        style={{ fontSize: "3rem", marginTop: ".75rem" }}
                      />
                    </div>
                    <span className="card-title mbr-fonts-style align-center display-5">
                      Deposit
                    </span>
                  </Button> */}
                    {/* <div className="card-wrapper" id="transactions_deposit_section">
									<div className="card-box align-center">
										<span
											className="mbr-iconfont material-add material"
											style={{ color: 'rgb(255, 255, 255)', fill: 'rgb(255, 255, 255)' }}
										/>
										<h4
											className="card-title align-center mbr-black mbr-fonts-style display-5"
											id="transactions_deposit_text"
										>
											<strong>Deposit</strong>
										</h4>
									</div>
								</div> */}
                  </div>
                </div>
              </div>
            </section>
            <BusinessTransactionsTableComponent
              handleClaim={this.handleFixForClaim.bind(this)}
              id={this.state.fixclaimid}
            />
            <Footer />
            <Modal
              title="Claim for a Fix !"
              visible={this.state.fixclaimmodal}
              onOk={this.handleOk}
              onCancel={this.handleCancel}
              footer={[
                <Button
                  className="btn btn-white display-4"
                  key="back"
                  onClick={this.handleCancel}
                >
                  Cancel
                </Button>,
                <Button
                  key="submit"
                  className="btn btn-black display-4"
                  onClick={this.handleOk}
                >
                  Submit
                </Button>,
              ]}
            >
              <p className="mbr-text mbr-fonts-style mb-4 display-4">
                Enter Your Reason
              </p>
              <TextArea
                rows={3}
                onChange={(value) => {
                  this.setState({ fixclaimreason: value.target.value });
                }}
              />
              <Switch
                onChange={(value) => {
                  this.setState({
                    fixclaimurgent: value,
                  });
                }}
              />
            </Modal>
          </div>
        );
      } else {
        return (
          <div className="row justify-content-center fullloading">
            <div className="col-lg-8 form-group">
              <Loading />
            </div>
          </div>
        );
      }
    } else {
      return <Redirect to="/" />;
    }
  }
}
const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    profile: state.profile,
    firebase: state.firebase,
    transactions: state.firestore.ordered.transaction,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getBusiness: () => dispatch(GetBusinessProfile()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BusinessTransactionsPage);
